import AppLoader from "@/components/AppLoader";
import useGetAuthData from "@/hooks/useGetAuthData";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useBackgroundPreloader } from "../contexts/BackgroundPreloaderContext";

const CheckAuthentication = () => {
    const { isBackgroundLoaded } = useBackgroundPreloader();
    const { handleLogin, isAuthenticated } = useGetAuthData();

    const isLoading = !isAuthenticated || !isBackgroundLoaded;

    useEffect(() => {
        if (!isAuthenticated) {
            handleLogin();
        }
    }, []);

    if (isLoading) {
        return <AppLoader />;
    }

    return <Outlet />;
};

export default CheckAuthentication;
